(() => {
  const productionHost = 'customize.huinasports.com';
  const localPreviewHosts = new Set(['127.0.0.1', 'localhost']);
  const localCustomizerHost = ['127', '0', '0', '1'].join('.');
  const localCustomizerPort = '3000';
  const localCustomizerPath = '/customize';
  const localBase = ['http://', localCustomizerHost, ':', localCustomizerPort].join('');
  const newOrderPath = '/pages/new-order';

  const isLocalPreviewHost = () => localPreviewHosts.has(window.location.hostname);

  const currentNewOrderUrl = () => new URL(newOrderPath, window.location.origin).href;

  const appendReturnUrl = (value) => {
    if (!value) {
      return value;
    }

    let parsed;

    try {
      parsed = new URL(value, window.location.href);
    } catch (_error) {
      return value;
    }

    if (parsed.hostname !== productionHost) {
      return value;
    }

    if (!parsed.searchParams.has('return_url')) {
      parsed.searchParams.set('return_url', currentNewOrderUrl());
    }

    return parsed.href;
  };

  const toLocalCustomizerUrl = (value) => {
    if (!value) {
      return value;
    }

    let parsed;

    try {
      parsed = new URL(value, window.location.href);
    } catch (_error) {
      return value;
    }

    if (parsed.hostname !== productionHost) {
      return value;
    }

    const path = parsed.pathname === '/' ? localCustomizerPath : parsed.pathname;
    return `${localBase}${path}${parsed.search}${parsed.hash}`;
  };

  const rewriteCustomizerLinks = () => {
    document.querySelectorAll('a[href]').forEach((anchor) => {
      const hrefWithReturn = appendReturnUrl(anchor.getAttribute('href'));
      const rewrittenHref = isLocalPreviewHost() ? toLocalCustomizerUrl(hrefWithReturn) : hrefWithReturn;

      if (rewrittenHref) {
        anchor.setAttribute('href', rewrittenHref);
      }
    });

    if (!isLocalPreviewHost()) {
      return;
    }

    document.querySelectorAll('[data-customizer-url]').forEach((element) => {
      const rewrittenUrl = toLocalCustomizerUrl(element.getAttribute('data-customizer-url'));

      if (rewrittenUrl) {
        element.setAttribute('data-customizer-url', rewrittenUrl);
      }
    });

    document.querySelectorAll('[data-customizer-api-url]').forEach((element) => {
      const rewrittenApiUrl = toLocalCustomizerUrl(element.getAttribute('data-customizer-api-url'));

      if (rewrittenApiUrl) {
        element.setAttribute('data-customizer-api-url', rewrittenApiUrl);
      }
    });
  };

  rewriteCustomizerLinks();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteCustomizerLinks, { once: true });
  }
})();
